    // Basic fixes
document.addEventListener('DOMContentLoaded', function () {
  $('img[src="//carex.com/cdn/shop/files/preview_images/ed39b1bdc7b8413684079df444bb64d3.thumbnail.0000000000_1080x.jpg?v=1724172420"]').attr('alt', 'Video Thumbnail Image');
    const brElements = document.querySelectorAll('br');
    
    brElements.forEach(br => br.setAttribute('aria-hidden', 'true'));
    
  });

 

// Drop-down Menu

document.addEventListener('click', function (event) {
  if (event.target.matches('.site-nav .has-dropdown > a')) {
      event.preventDefault();

      // Find the clicked dropdown's parent element
      const parentElement = event.target.closest('li.has-dropdown');

      if (parentElement) {
          // Close all other open dropdowns
          const openDropdowns = document.querySelectorAll('li.has-dropdown.dropdown-hover');
          openDropdowns.forEach(function (dropdown) {
              if (dropdown !== parentElement) {
                  dropdown.classList.remove('dropdown-hover');
                  const dropdownMenu = dropdown.querySelector('ul.dropdown');
                  if (dropdownMenu) {
                      dropdownMenu.setAttribute('aria-hidden', 'true');
                  }
                  const link = dropdown.querySelector('a[aria-expanded]');
                  if (link) {
                      link.setAttribute('aria-expanded', 'false');
                  }
              }
          });

          // Toggle the clicked dropdown
          const isExpanded = parentElement.classList.toggle('dropdown-hover');
          event.target.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

          const dropdownMenu = parentElement.querySelector('ul.dropdown');
          if (dropdownMenu) {
              dropdownMenu.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
          }
      }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
      // Find all open dropdowns
      const openDropdowns = document.querySelectorAll('li.has-dropdown.dropdown-hover');

      openDropdowns.forEach(function (dropdown) {
          // Remove the 'dropdown-hover' class to close the dropdown
          dropdown.classList.remove('dropdown-hover');

          // Set 'aria-hidden' to 'true' on the associated 'ul.dropdown'
          const dropdownMenu = dropdown.querySelector('ul.dropdown');
          if (dropdownMenu) {
              dropdownMenu.setAttribute('aria-hidden', 'true');
          }

          // Set 'aria-expanded' to 'false' on the 'a' inside the 'li.has-dropdown'
          const dropdownLink = dropdown.querySelector('a[aria-expanded]');
          if (dropdownLink) {
              dropdownLink.setAttribute('aria-expanded', 'false');
          }
      });
  }
});

  // For Add to Cart Focus
document.addEventListener('DOMContentLoaded', () => {
  const addToCartButtons = document.querySelectorAll('.grid-add-to-cart');
  const cartPreviewPopup = document.querySelector('.cart-preview');
  let lastClickedButton = null;

  if (addToCartButtons && cartPreviewPopup) {
    // Add click event listeners to all add-to-cart buttons
    addToCartButtons.forEach(button => {
      button.addEventListener('click', () => {
        lastClickedButton = button; // Store the clicked button
        setTimeout(() => {
          cartPreviewPopup.style.display = 'block'; // Show the popup
          cartPreviewPopup.focus();

          // Automatically hide the popup after a few seconds
          setTimeout(() => {
            cartPreviewPopup.style.display = 'none'; // Hide the popup
            if (lastClickedButton) {
              lastClickedButton.focus(); // Return focus to the clicked button
            }
          }, 5000); 
        }, 2000); 
      });
    });
  }
});


// For Product Page Cart
document.addEventListener('DOMContentLoaded', () => {
  const addToCartButtons = document.querySelectorAll('button[data-pf-type="ProductATC"]');
  const cartPreviewPopup = document.querySelector('.cart-preview');
  let lastClickedButton = null;

  if (addToCartButtons && cartPreviewPopup) {
    // Add click event listeners to all add-to-cart buttons
    addToCartButtons.forEach(button => {
      button.addEventListener('click', () => {
        lastClickedButton = button; // Store the clicked button
        setTimeout(() => {
          cartPreviewPopup.style.display = 'block'; // Show the popup
          cartPreviewPopup.focus();

          // Automatically hide the popup after a few seconds
          setTimeout(() => {
            cartPreviewPopup.style.display = 'none'; // Hide the popup
            if (lastClickedButton) {
              lastClickedButton.focus(); // Return focus to the clicked button
            }
          }, 5000); 
        }, 2000); 
      });
    });
  }
});

// Price Labels
setTimeout(function() {
  document.querySelectorAll('[data-product-price]').forEach(function(element) {
    var span = document.createElement('span');
    span.className = 'visually-hidden';
    span.textContent = 'Regular Price';
    element.insertBefore(span, element.firstChild);
  });
}, 2000);

// For Sale Prices
document.querySelectorAll('.original-price.money').forEach(element => {
  const visuallyHiddenSpan = document.createElement('span'); 
  visuallyHiddenSpan.className = 'visually-hidden'; 
  visuallyHiddenSpan.textContent = 'Regular Price'; 
  element.insertBefore(visuallyHiddenSpan, element.firstChild); 
});

document.querySelectorAll('.money.sale-price').forEach(element => {
  const visuallyHiddenSpan = document.createElement('span'); 
  visuallyHiddenSpan.className = 'visually-hidden'; 
  visuallyHiddenSpan.textContent = 'Sale Price'; 
  element.insertBefore(visuallyHiddenSpan, element.firstChild); 
});

document.addEventListener("DOMContentLoaded", function () {
  const link = document.querySelector('a[href="https://hpi.georgetown.edu/backpain/"]');
  if (link) {
    link.setAttribute(
      'aria-label',
      'Health Policy Institute, This Link will open in a new tab.'
    );
  }
});

// External Links Warning

document.addEventListener('DOMContentLoaded', function () {
    var thirdPartyLinks = document.querySelectorAll('main#main-content a');

    // Function to check if a link is from a third-party website
    function isThirdParty(url) {
        // Skip empty or invalid URLs
        if (!url || typeof url !== 'string') return false;

        // Skip internal links that start with "/" or "#"
        if (url.startsWith('/') || url.startsWith('#')) return false;

        // Skip links that include the current domain
        if (url.includes('carex.com')) return false;

        // All other cases are considered third-party
        return true;
    }

    // Loop through each link
    thirdPartyLinks.forEach(function (link) {
        // Skip links that contain an <img> element
        var img = link.querySelector('img');
        if (img) {
            // Check if the link is third-party
            if (isThirdParty(link.href)) {
                var altText = img.alt || ''; // Get alt text, default to an empty string if not present

                // Add a custom message to the alt text
                if (altText) {
                    altText += ', This link will open in a new tab';
                } else {
                    altText = 'This link will open in a new tab';
                }

                img.alt = altText; // Update the image's alt attribute
            }
            return; // Skip further processing for this link
        }

        // Check if the link leads to a third-party website
        if (isThirdParty(link.href)) {
            // Add the target="_blank" attribute
            link.target = '_blank';

            // Add an aria-label indicating it will open in a new tab
            var existingText = link.textContent.trim();
            var newText = existingText + ', This link will open in a new tab';
            link.setAttribute('aria-label', newText);
        }
    });
});

  // Accrodine Tab for Images
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('button[data-pf-type="Accordion.Header"]').forEach(button => {
      button.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
      });
    });
  
    document.querySelectorAll('button[data-pf-type="Accordion.Header"]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
  }); 

  // Quantity Stepper
  document.addEventListener('DOMContentLoaded', function () {
    const attributeUpdates = [
      {
        selector: 'button[data-quantity-action="increase"]',
        attribute: 'aria-label',
        value: 'Increase quantity by 1',
      },
      {
        selector: 'button[data-quantity-action="decrease"]',
        attribute: 'aria-label',
        value: 'Decrease quantity by 1',
      },
      {
        selector: 'input[data-pf-type="QuantityField"]',
        attribute: 'aria-label',
        value: 'Quantity',
      },
      {
        selector: 'a[href="https://www.getgobot.com/kb/-LsruHzEQpIkwzYNce98"]',
        attribute: 'aria-label',
        value: 'Knowledge Base, this link will open in a new tab',
      },
      {
        selector: 'a[href="https://dovetale.com/community/apply/WlfzDrvSHBM"]',
        attribute: 'aria-label',
        value: 'Become a Carex Ambassador, this link will open in a new tab',
      },
    ];
  
    attributeUpdates.forEach(({ selector, attribute, value }) => {
      document.querySelectorAll(selector).forEach(element => {
        element.setAttribute(attribute, value);
      });
    });
  });

  // Accordion Buttons 
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pf-type="Accordion3.Header"]').forEach(button => {
      button.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
      });
    });
  
    document.querySelectorAll('[data-pf-type="Accordion3.Header"]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('role', 'button');
    });
  });

$(document).ready(function() {
  var asideContainer = $('.collection .aside-container');
  var collectionContainer = $('.collection-container');
  asideContainer.detach().prependTo('.collection .grid');
  collectionContainer.detach().appendTo('.collection .grid');
  $('.glide-wrapper.glider-slide div').removeAttr('aria-label');
  $('img[src="https://cdn.shopify.com/s/files/1/0240/6504/8681/files/CarexTrustIcons_09192024_ProductWarranty_1200x.jpg?v=1726837135"]').attr('alt','Customer Support We are always here for you');
  $('.appstle_tooltip_content p a[href="https://carex.com/pages/subscribe-and-save"]').attr('aria-label','Learn More, About Subscription');
  $("p.simpAnswerHolder a").each(function() {
    if ($.trim($(this).text()) === "") {
        $(this).remove(); // Remove the link if it is empty
    }
});
$('.image-cell svg.placeholder-svg').attr('alt','empty Image');
$('.image-cell svg.placeholder-svg').prepend('<span class="visually-hidden">Empty Image</span>');
  setTimeout(function () {
    $('iframe').attr('title', 'iframe');
    $('.tdf_checkbox_wrapper').prepend('<span class="visually-hidden">Select the Ticket checkbox if you want to select it for the cart.</span>');
    $('.tdf_bundle.tdf_container .tdf_bundle_style_5 .tdf_vertical_product .tdf_select_input').attr('aria-label','Variants');
    $('.appstle_tooltip_content p a[href="https://carex.com/pages/subscribe-and-save"]').attr('aria-label','Learn More Aout Subscription And Save');
}, 2000);
});

// Press Page Warning
document.addEventListener("DOMContentLoaded", function() {
  // List of URLs to check
  var urls = [
      "https://www.cnet.com/health/best-sad-light-therapy-lamp/",
      "https://greatist.com/discover/sun-lamp#carex",
      "https://www.popsci.com/gear/best-light-therapy-lamps/",
      "https://optimizeyourbiology.com/best-sad-light-therapy-lamps",
      "https://www.usnews.com/360-reviews/home-goods/best-light-therapy-lamps",
      "https://www.today.com/shop/best-light-therapy-lamp-t206362",
      "https://www.nytimes.com/wirecutter/reviews/best-light-therapy-lamp/",
      "https://www.retailmenot.com/blog/light-therapy-lamps-deals.html",
      "https://www.forbes.com/health/mind/best-light-therapy-lamps/",
      "https://www.yourhomestyle.uk/buyers-guides/best-sad-lamps",
      "https://youtu.be/OJZ4pjzwDLU?si=BNYseSRJbU9mUmPM&t=70",
      "https://nymag.com/strategist/article/best-sad-lamps.html",
      "https://www.mindbodygreen.com/articles/sun-lamps",
      "https://parade.com/1121585/korinmiller/seasonal-affective-disorder-lamps/",
      "https://www.prevention.com/health/g38017646/best-sad-light-therapy-lamps/",
      "https://www.wellandgood.com/sad-lamps/",
      "https://www.nbcnews.com/select/shopping/verilux-therapy-lamp-ncna1285504",
      "https://theangle.digitaltrends.com/electronics/best-lamps-for-light-therapy/",
      "https://medicine.yale.edu/psychiatry/research/programs/clinical_people/winter/obtain/",
      "https://www.bustle.com/life/best-light-therapy-lamps",
      "https://www.mensjournal.com/health-fitness/best-therapy-lights"
  ];

  // Get all links in the document
  var links = document.querySelectorAll('a');

  links.forEach(function(link) {
      // Check if the link's href matches one of the specified URLs
      if (urls.includes(link.href)) {
          var originalTitle = link.textContent.trim();
          var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '...' : originalTitle;
          var ariaLabelText = trimmedTitle + ' (opens in a new window)';

          // Check if the link is inside a specific container with an h2
          var closestDiv = link.closest('div');
          if (closestDiv && closestDiv.querySelector('h2')) {
              var h2Text = closestDiv.querySelector('h2').textContent.trim();
              ariaLabelText = trimmedTitle + ', ' + h2Text + ' (opens in a new window)';
          }

          // Update the aria-label and other attributes
          link.setAttribute('aria-label', ariaLabelText);
          link.setAttribute('target', '_blank');
          link.removeAttribute('title');
      }
  });
});

// Read More On Press
$(document).ready(function () {
  // Iterate over each "Read More" link
  $(".rte p.read-more a.button.outline").each(function () {
      // Find the closest header with an h2 element relative to the current link
      var trimmedText = $(this).closest(".grid-item").find("header.centered h2").text().trim();

      // Add the aria-label with the specific trimmed text
      $(this).attr("aria-label", "Read More, " + trimmedText);
  });
});


